export const creteilPostalCode: string[] = ['94000'];
